<template>
  <div>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomSelect :value="formData.work_set_check_group_id" label="Текущая рабочая группа" :options="groupOptions"
          option-label-key="label" option-value-key="work_set_check_group_id" :required="true" :use-input="true"
          :clearable="true" @change="onChangeGroup" />
      </div>

      <div class="form__item">
        <CustomSelect :value="formData.prev_work_set_check_group_id" label="Предыдущая рабочая группа"
          :options="groupOptions" option-label-key="label" option-value-key="work_set_check_group_id" :required="true"
          :use-input="true" :clearable="true" @change="onChangePrevGroup" />
      </div>

      <div class="form__item">
        <CustomSelect :value="formData.company_id" label="Название компании" :options="companyOptions"
          option-label-key="company_name" option-value-key="company_id" :required="true" :use-input="true"
          :clearable="true" @change="onChangeCompany"  />
      </div>
      <div class="form__item"></div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { workSetCheckGroupsAPI } from "@/views/WorkSetCheckGroups/api";

export default {
  name: "add-work-set-check-groups-link",
  components: {
    CustomInput,
    CustomSelect,
    CustomModalFooter,
  },
  props: ["data"],
  data() {
    return {
      loading: false,
      groupOptions: [],
      companyOptions: [],
      formData: {
        work_set_check_group_id: this.data?.body?.work_set_check_group_id || "",
        prev_work_set_check_group_id:
          this.data?.body?.prev_work_set_check_group_id || "",
        company_id: this.data?.body?.company_id ? String(this.data?.body?.company_id) : "",
      },
    };
  },
  methods: {
    async fetchGroupOptions() {
      try {
        const response = await workSetCheckGroupsAPI.getList();
        if (response && response.data && Array.isArray(response.data)) {
          this.groupOptions = response.data.map((group) => ({
            work_set_check_group_id: group.work_set_check_group_id,
            label: group.work_set_check_group_name,
          }));
        }
      } catch (e) {
        this.groupOptions = [];
      }
    },

    async fetchCompanyOptions() {
      try {
        const response = await workSetCheckGroupsAPI.getCompanies();
        console.log("response from add-work-set-check-groups-link", response)
        if (response && response.data && Array.isArray(response.data)) {
          this.companyOptions = response.data;
        }
      } catch (e) {
        this.companyOptions = [];
        console.error("Error fetching company options:", e);
      }
    },

    onChange(key, value) {
      this.formData[key] = value;
    },

    onChangeGroup(value) {
      this.formData.work_set_check_group_id = value;
    },

    onChangePrevGroup(value) {
      this.formData.prev_work_set_check_group_id = value;
    },

    onChangeCompany(value) {
      this.formData.company_id = value;
    },

    validateFormData() {
      const errors = [];

      if (!this.formData.work_set_check_group_id) {
        errors.push("Текущая рабочая группа обязательна");
      }

      if (!this.formData.prev_work_set_check_group_id) {
        errors.push("Предыдущая рабочая группа обязательна");
      }

      if (!this.formData.company_id) {
        errors.push("Компания обязательна");
      }

      return errors;
    },

    cleanFormData() {
      const cleanedData = { ...this.formData };

      Object.keys(cleanedData).forEach((key) => {
        if (
          cleanedData[key] === "" ||
          cleanedData[key] === null ||
          cleanedData[key] === undefined
        ) {
          delete cleanedData[key];
        }
      });

      return cleanedData;
    },

    async onSubmit() {
      this.loading = true;

      const errors = this.validateFormData();
      if (errors.length > 0) {
        this.$q.notify({
          type: "negative",
          message: errors.join(", "),
        });
        this.loading = false;
        return;
      }

      const cleanedData = this.cleanFormData();
      try {
        await this.data?.onSubmit(cleanedData);
      } catch (error) {
        this.$q.notify({
          type: "negative",
          message: "Ошибка при сохранении данных",
        });
        console.error("Error submitting form:", error);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await Promise.all([this.fetchGroupOptions(), this.fetchCompanyOptions()]);
  
    if (!this.formData.company_id && this.data?.body?.company_name) {
      const foundCompany = this.companyOptions.find(company => 
        company.company_name === this.data.body.company_name
      );
      if (foundCompany) {
        this.formData.company_id = foundCompany.company_id;
      }
    }
  },
};
</script>

<style scoped lang="scss">
.form {
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: 6fr 6fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 12fr;
  }

  .form__item {
    flex: 1 1 45%;
  }
}
</style>